<div class="container">
  <div class="loader">
      <img class="loading-indicator" src="/assets/img/image-loading-darkblue.svg" alt="Loading..." />
      <span>The registration page is loading…</span>
  </div>
</div>